import { TransformEx } from "../../LTGame/LTUtils/TransformEx";
import LTRes from "../../LTGame/Res/LTRes";
import ResDefine from "../common/ResDefine";
import { ItemConfig } from "../config/ItemConfig";
export default class TextManager {
    PreLoad(urls) {
        this.PushObjToList(urls, ResDefine.skillTypePath);
        this.PushObjToList(urls, ResDefine.timeTypePath);
        this.PushObjToList(urls, ResDefine.mathTypePath);
        this.PushObjToList(urls, ResDefine.valuePath);
    }
    PushObjToList(urls, obj) {
        for (let k in obj) {
            urls.push(ResDefine.FixPath(obj[k]));
        }
    }
    InitText(content, types) {
        let type = content.getChildByName("type");
        type.removeChildren();
        let value = content.getChildByName("value");
        value.removeChildren();
        let config = ItemConfig.data[types[0]];
        let typePath;
        let timeType = types[1];
        let mathType = types[2];
        let valueStr = types[3].toString();
        if (config.item_type == 1) {
            if (timeType == 1) {
                typePath = ResDefine.FixPath(ResDefine.timeTypePath.Year);
            }
            else if (timeType == 2) {
                typePath = ResDefine.FixPath(ResDefine.timeTypePath.Day);
            }
            else if (timeType == 3) {
                typePath = ResDefine.FixPath(ResDefine.timeTypePath.People);
            }
            else if (timeType == 4) {
                typePath = ResDefine.FixPath(ResDefine.timeTypePath.Month);
            }
        }
        else {
            if (timeType == 1) {
                typePath = ResDefine.FixPath(ResDefine.skillTypePath.fire_rate);
            }
            else if (timeType == 2) {
                typePath = ResDefine.FixPath(ResDefine.skillTypePath.damage_rate);
            }
        }
        let typeItem = LTRes.Get(typePath);
        type.addChild(typeItem);
        TransformEx.ResetLocalTrans(typeItem.transform);
        let signStr;
        switch (mathType) {
            case 1:
                signStr = "+";
                break;
            case 2:
                signStr = "-";
                break;
            case 3:
                signStr = "*";
                break;
            case 4:
                signStr = "/";
                break;
        }
        let item = LTRes.Get(ResDefine.FixPath(ResDefine.mathTypePath[signStr]));
        value.addChild(item);
        TransformEx.ResetLocalTrans(item.transform);
        let len = valueStr.length;
        let w = 0.8;
        item.transform.localPositionX = (len + 1) * w / 2 - w / 2;
        for (let i = 0; i < len; i++) {
            let str = valueStr[i];
            let item = LTRes.Get(ResDefine.FixPath(ResDefine.valuePath[str]));
            value.addChild(item);
            TransformEx.ResetLocalTrans(item.transform);
            item.transform.localPositionX = -(i + 1) * w + (len + 1) * w / 2 - w / 2;
        }
    }
}
